import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Checkbox as AntCheckbox, Form, Icon, Popover } from 'antd'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { THEME } from '../constants'

const StyledCheckbox = styled.div`
  .ant-checkbox-wrapper .ant-checkbox-inner {
    border-color: ${props => props.color};
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: ${props => props.color};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${props => props.color};
  }
`

const getColor = highlighted =>
  highlighted ? THEME.colors.lavender : undefined

const Checkbox = ({
  name,
  label,
  text,
  infoMessage,
  onCheckboxChange,
  highlighted,
  ...rest
}) => {
  const { control } = useFormContext()

  return (
    <Form.Item label={label}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Controller
          control={control}
          name={name}
          render={({ onChange, value, ...props }) => (
            <StyledCheckbox color={getColor(highlighted)}>
              <AntCheckbox
                {...props}
                checked={value}
                onChange={e => {
                  onChange(e.target.checked)
                  if (onCheckboxChange) onCheckboxChange(e.target.checked)
                }}
                name={name}
                {...rest}
              >
                {text}
              </AntCheckbox>
            </StyledCheckbox>
          )}
        />
        {infoMessage && (
          <div style={{ marginLeft: '10px' }}>
            <Popover content={infoMessage} placement="left">
              <Icon type="info-circle" />
            </Popover>
          </div>
        )}
      </div>
    </Form.Item>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  text: PropTypes.string,
  infoMessage: PropTypes.string,
  onCheckboxChange: PropTypes.func,
  highlighted: PropTypes.bool,
}

Checkbox.defaultProps = {
  label: '',
  text: '',
  infoMessage: '',
  onCheckboxChange: undefined,
  highlighted: false,
}

export default Checkbox
